import { render, staticRenderFns } from "./dialog_release.vue?vue&type=template&id=2cc19372&scoped=true&"
import script from "./dialog_release.vue?vue&type=script&lang=js&"
export * from "./dialog_release.vue?vue&type=script&lang=js&"
import style0 from "./dialog_release.vue?vue&type=style&index=0&id=2cc19372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc19372",
  null
  
)

export default component.exports